var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skin-color-template',{attrs:{"gender":_vm.gender,"skin-color-allowed-values":_vm.skinColorAllowedValues,"skin-color":_vm.skinColor,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }